<template>
  <div class="register">
    <h1 class="top">Bodor+3.0 {{ $t("register.new") }}</h1>
    <div class="regbox">
      <div class="back" @click="back">{{ $t("register.back") }}</div>
      <h3>{{ $t("register.register") }}</h3>
      <a-form
        class="inputbox"
        ref="formRef"
        :model="formState"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item v-if="isChina && !isCam" :label="$t('register.phone')" name="phone">
          <a-input
            v-model:value="formState.phone"
            :placeholder="$t('register.phonein')"
            :disabled="phoneDis"
          />
        </a-form-item>
        <a-form-item v-else :label="$t('register.email')" name="email">
          <a-input
            v-model:value="formState.email"
            :placeholder="$t('register.emailin')"
            :disabled="emailDis"
          />
        </a-form-item>
        <!--         <a-form-item :label="$t('register.account')" name="account">
          <a-input
            v-model:value="formState.account"
            :placeholder="$t('register.accountin')"
          />
        </a-form-item> -->
        <a-form-item :label="$t('register.password')" name="password">
          <a-input
            type="password"
            v-model:value="formState.password"
            autocomplete="off"
            :placeholder="$t('register.passwordin')"
          />
        </a-form-item>
        <a-form-item :label="$t('register.confirm')" name="confirm">
          <a-input
            type="password"
            v-model:value="formState.confirm"
            :placeholder="$t('register.confirmin')"
            autocomplete="off"
          />
        </a-form-item>
        <!--         <a-form-item :label="$t('register.name')" name="name">
          <a-input v-model:value="formState.name" :placeholder="$t('register.namein')" />
        </a-form-item> -->
        <!--         <a-form-item v-if="isChina" :label="$t('register.email')" name="email">
          <a-input
            v-model:value="formState.email"
            :placeholder="$t('register.emailin')"
            :disabled="emailDis"
          />
        </a-form-item>
        <a-form-item v-else :label="$t('register.phone')" name="phone">
          <a-input
            v-model:value="formState.phone"
            :placeholder="$t('register.phonein')"
            :disabled="phoneDis"
          />
        </a-form-item> -->
        <a-form-item :label="$t('register.address')" name="address">
          <a-row :gutter="[12, 12]">
            <a-col :span="12">
              <a-form-item-rest>
                <a-cascader
                  style="width: 100%"
                  v-model:value="formState.nation"
                  :options="nationList"
                  :placeholder="$t('register.addressin1')"
                  :fieldNames="addressFieldNames"
                  :show-search="{ filter }"
                  @change="onNationChange"
                  :allowClear="false"
                />
              </a-form-item-rest>
            </a-col>
            <a-col :span="12">
              <a-form-item-rest>
                <a-cascader
                  style="width: 100%"
                  v-model:value="formState.province"
                  :options="provinceList"
                  :placeholder="$t('register.addressin2')"
                  :fieldNames="addressFieldNames"
                  :show-search="{ filter }"
                  @change="onProvinceChange"
                  :disabled="provinceDis"
                  :allowClear="false"
                />
              </a-form-item-rest>
            </a-col>
            <a-col :span="12">
              <a-form-item-rest>
                <a-cascader
                  style="width: 100%"
                  v-model:value="formState.city"
                  :options="cityList"
                  :placeholder="$t('register.addressin3')"
                  :fieldNames="addressFieldNames"
                  :show-search="{ filter }"
                  @change="onCityChange"
                  :disabled="cityDis"
                  :allowClear="false"
                />
              </a-form-item-rest>
            </a-col>
            <a-col :span="12">
              <a-form-item-rest>
                <a-cascader
                  style="width: 100%"
                  v-model:value="formState.county"
                  :options="countyList"
                  :placeholder="$t('register.addressin4')"
                  :fieldNames="addressFieldNames"
                  :show-search="{ filter }"
                  @change="onCountyChange"
                  :disabled="countyDis"
                  :allowClear="false"
                />
              </a-form-item-rest>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
          :label="isCam ? $t('register.emailcode') : $t('register.code')"
          name="code"
        >
          <a-row :gutter="12">
            <a-col :span="12">
              <a-input
                v-model:value="formState.code"
                :placeholder="$t('register.codein')"
              />
            </a-col>
            <a-col :span="10">
              <a-form-item-rest>
                <div
                  v-if="isChina && !isCam"
                  :class="[isDisabled ? 'disabledbtn' : 'codebtn']"
                  @click="phoneCode"
                >
                  <span ref="codeinfo">{{ $t("register.getCode") }}</span>
                </div>
                <div
                  v-else
                  :class="[isDisabled ? 'disabledbtn' : 'codebtn']"
                  @click="emailCode"
                >
                  <span ref="codeinfo">{{ $t("register.getCode") }}</span>
                </div>
                <a-checkbox
                  v-if="checkShow"
                  style="margin-top: 10px"
                  v-model:checked="artificial"
                  @change="checked"
                  >{{ $t("register.noCode") }}?</a-checkbox
                >
              </a-form-item-rest>
            </a-col>
          </a-row>
        </a-form-item>
        <!--         <form class="codebox">
          <input type="text" name="code" placeholder="请输入验证码" autocomplete="off" />
          <div :class="[isDisabled ? 'disabledbtn' : 'codebtn']" @click="code">
            <span ref="codeinfo">获取验证码</span>
          </div>
        </form> -->
      </a-form>
      <a-button type="primary" class="regbtn" @click="register" :loading="btnLoading">
        {{ registerBtn }}</a-button
      >
      <!-- <div class="regbtn" @click="register">{{ $t("register.register") }}</div> -->
    </div>
    <a-modal
      v-model:open="isModalOpen"
      title="是否使用CAM软件?"
      ok-text="提交"
      :cancel-text="cancelWord"
      @ok="submitEmail"
      @cancel="cancelModal"
      :closable="false"
      :maskClosable="false"
      :keyboard="false"
      :cancel-button-props="{ disabled: cancelDis }"
    >
      <p>
        如果要使用套料软件需要在此绑定邮箱并使用<span style="color: red">邮箱登录</span
        >套料软件
      </p>
      <a-form
        ref="modalFormRef"
        :model="modalFormState"
        layout="vertical"
        name="changeEmail"
      >
        <a-form-item
          name="email"
          :label="$t('register.email')"
          :rules="[{ required: true, message: $t('register.emailEmpty') }]"
        >
          <a-input v-model:value="modalFormState.email" :disabled="modalEmailDis" />
        </a-form-item>
        <a-form-item
          :label="$t('user.code')"
          name="code"
          :rules="[{ required: true, message: $t('register.codeEmpty') }]"
        >
          <a-row :gutter="12">
            <a-col :span="16">
              <a-input
                v-model:value="modalFormState.code"
                :placeholder="$t('register.codein')"
              />
            </a-col>
            <a-col :span="8">
              <a-form-item-rest>
                <div
                  :class="[isCodeDisabled ? 'disabledbtn' : 'codebtn']"
                  @click="modalEmailCode"
                >
                  <span ref="modalCodeinfo">{{ $t("register.getCode") }}</span>
                </div>
              </a-form-item-rest>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { Modal } from "ant-design-vue";
import { h } from "vue";
import { useI18n } from "vue-i18n";

const i18n = useI18n();

const { t } = useI18n();

const account = ref();
const password = ref();
const confirm = ref();
const email = ref();
const name = ref();
const phone = ref();
const address = ref([]);
const FullPathName = ref("");
const FullPathId = ref("");
const addressFieldNames = { label: "countryname", value: "countryid" };
const addressList = ref([]);
const nationList = ref([]);
const provinceList = ref([]);
const cityList = ref([]);
const countyList = ref([]);
const btnLoading = ref(false);
const provinceDis = ref(true);
const cityDis = ref(true);
const countyDis = ref(true);
const VCode = ref(null);
const artificial = ref(false);
const checkShow = ref(false);
const isChina = ref(localStorage.getItem("lang") == "zh");
const isCam = ref(false);
const lang = ref();
const isModalOpen = ref(false);
const modalFormState = ref({});
const modalFormRef = ref();
const nowAccount = ref();
const nowPassword = ref();
const isCodeDisabled = ref(false);
const modalCode = ref(null);
const modalEmailDis = ref(false);
const cancelWord = computed(() => {
  return modalFormState.value.email
    ? "若不想绑定邮箱,请先清空输入框"
    : "不,我不使用套料软件";
});
const cancelDis = computed(() => {
  return modalFormState.value.email ? true : false;
});

const route = useRoute();

getUrl();

const registerBtn = computed(() => {
  return artificial.value ? t("register.submit") : t("register.register");
});

const formRef = ref();
const labelCol = {
  span: 5,
};
const wrapperCol = {
  span: 19,
};
const emailDis = ref(false);
const phoneDis = ref(false);
const formState = ref({
  account: undefined,
  password: undefined,
  confirm: undefined,
  email: undefined,
  name: undefined,
  phone: undefined,
  nation: undefined,
  province: undefined,
  city: undefined,
  county: undefined,
  code: undefined,
});
let rules = {
  /*   account: [
    {
      required: true,
      message: t("register.accountEmpty"),
      trigger: "change",
    },
  ], */
  phone: [
    {
      required: isChina.value && !isCam.value,
      message: t("register.phoneEmpty"),
      trigger: "change",
    },
  ],
  email: [
    {
      required: !isChina.value || isCam.value,
      message: t("register.emailEmpty"),
      trigger: "change",
    },
  ],
  password: [
    {
      required: true,
      message: t("register.passwordEmpty"),
      trigger: "change",
    },
  ],
  confirm: [
    {
      required: true,
      message: t("register.confirmEmpty"),
      trigger: "change",
    },
  ],
  /*   name: [
    {
      required: true,
      message: t("register.nameEmpty"),
      trigger: "change",
    },
  ], */
  address: [
    {
      required: true,
      message: t("register.addressEmpty"),
      trigger: "change",
    },
  ],
  code: [
    {
      required: true,
      message: t("register.codeEmpty"),
      trigger: "change",
    },
  ],
};

function countryArea(type, fid) {
  type = type.toString();
  fid = fid.toString();

  axios
    .post("api/User/GetAreaData", {
      seltype: type,
      fid: fid,
    })
    .then((response) => {
      if (response.data.code !== 200) {
        message.error(response.data.info);
      } else {
        if (type == "1") {
          nationList.value = response.data.ReturnData;
        } else if (type == "2") {
          provinceList.value = response.data.ReturnData;
        } else if (type == "3") {
          cityList.value = response.data.ReturnData;
        } else if (type == "4") {
          countyList.value = response.data.ReturnData;
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

const filter = (inputValue, path) => {
  return path.some(
    (option) => option.countryname.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
};

const back = () => {
  router.push("/login");
};

const onNationChange = (_value, selectedOptions) => {
  FullPathId.value = [_value];
  address.value = [selectedOptions[0].countryname];

  countryArea("2", _value);
  formState.value.province = undefined;
  formState.value.city = undefined;
  formState.value.county = undefined;

  provinceDis.value = false;
  cityDis.value = true;
  countyDis.value = true;
};

const onProvinceChange = (_value, selectedOptions) => {
  FullPathId.value = [FullPathId.value[0], _value];
  address.value = [address.value[0], selectedOptions[0].countryname];

  countryArea("3", _value);
  formState.value.city = undefined;
  formState.value.county = undefined;

  cityDis.value = false;
  countyDis.value = true;
};

const onCityChange = (_value, selectedOptions) => {
  FullPathId.value = [FullPathId.value[0], FullPathId.value[1], _value];
  address.value = [address.value[0], address.value[1], selectedOptions[0].countryname];

  countryArea("4", _value);
  formState.value.county = undefined;

  countyDis.value = false;
};

const onCountyChange = (_value, selectedOptions) => {
  FullPathId.value = [
    FullPathId.value[0],
    FullPathId.value[1],
    FullPathId.value[2],
    _value,
  ];
  address.value = [
    address.value[0],
    address.value[1],
    address.value[2],
    selectedOptions[0].countryname,
  ];
};

countryArea(1, "");

let router = useRouter();
let count = ref(60);
const codeinfo = ref(null);
const modalCodeinfo = ref(null);
let isDisabled = ref(false);
let intervalId; // 添加此变量，用于存储定时器的ID
let modalIntervalId;
const startCountdown = () => {
  intervalId = setInterval(() => {
    if (count.value > 0) {
      codeinfo.value.textContent = count.value + "s" + t("register.wait");
      count.value--;
    } else {
      clearInterval(intervalId);
      codeinfo.value.textContent = t("register.getCode");
      isDisabled.value = false;
      checkShow.value = true;
    }
  }, 1000);
};
const startModalCountdown = () => {
  modalIntervalId = setInterval(() => {
    if (count.value > 0) {
      modalCodeinfo.value.textContent = count.value + "s" + t("register.wait");
      count.value--;
    } else {
      clearInterval(modalIntervalId);
      modalCodeinfo.value.textContent = t("register.getCode");
      isCodeDisabled.value = false;
    }
  }, 1000);
};
const emailVer = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phoneVer = /^(\+|\d{1,3})\s?(\d{1,4})?\s?\(?\d{1,4}\)?\s?\d{1,4}\s?\-?\d{1,9}$/;

const register = () => {
  if (!formState.value.email && (!isChina.value || isCam.value)) {
    message.error(t("register.emailEmpty"));
    return;
  }
  if (!formState.value.phone && isChina.value && !isCam.value) {
    message.error(t("register.phoneEmpty"));
    return;
  }
  if (!formState.value.password) {
    message.error(t("register.passwordEmpty"));
    return;
  }
  if (!address.value) {
    message.error(t("register.addressEmpty"));
    return;
  }
  if (formState.value.email && !formState.value.email.match(emailVer)) {
    message.error(t("register.emailError"));
    return;
  }
  if (formState.value.phone && !formState.value.phone.match(phoneVer)) {
    message.error(t("register.phoneError"));
    return;
  }
  if (formState.value.password != formState.value.confirm) {
    message.error(t("register.confirmEmpty"));
    return;
  }
  //如果用户获取验证码失败，则走提交审核接口
  if (artificial.value) {
    function sendEmailError() {
      btnLoading.value = true;
      axios
        .post("api/User/SaveEmailErrorUser", {
          Account: formState.value.email ? formState.value.email : formState.value.phone,
          RealName: formState.value.email ? formState.value.email : formState.value.phone,
          Mobile: formState.value.phone ? formState.value.phone : "",
          Email: formState.value.email ? formState.value.email : "",
          FullPathId: FullPathId.value.join("-"),
          FullPathName: address.value.join("/"),
          Password: formState.value.password,
          IsDomestic: isChina.value ? "1" : "0",
          CreateOrigin: "0",
        })
        .then(function (response) {
          btnLoading.value = false;
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            info();
            router.push("/login");
          }
        })
        .catch(function (error) {});
    }
    if (formState.value.email) {
      axios
        .post("api/User/GetUserEmail", {
          Email: formState.value.email,
        })
        .then(function (response) {
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            if (response.data.ReturnData.length > 0) {
              message.error(t("register.emailDuplicate"));
            } else {
              sendEmailError();
            }
          }
        })
        .catch(function (error) {});
    } else {
      sendEmailError();
    }
  } else {
    //否则走正常提交审核接口
    if (formState.value.code != VCode.value) {
      message.error(t("register.codeErr"));
      return;
    }
    let params = {
      Account:
        isChina.value && !isCam.value ? formState.value.phone : formState.value.email,
      RealName:
        isChina.value && !isCam.value ? formState.value.phone : formState.value.email,
      Mobile: formState.value.phone ? formState.value.phone : "",
      Email: formState.value.email ? formState.value.email : "",
      FullPathId: FullPathId.value.join("-"),
      FullPathName: address.value.join("/"),
      Password: formState.value.password,
      IsDomestic: isChina.value ? "1" : "0",
      CreateOrigin: "0",
    };
    if (isChina.value && !isCam.value) {
      btnLoading.value = true;
      axios
        .post("api/User/SaveUser", params)
        .then(function (response) {
          btnLoading.value = false;
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            clearInterval(intervalId);
            codeinfo.value.textContent = t("register.getCode");
            isDisabled.value = false;
            checkShow.value = true;
            if (!isChina.value) {
              Modal.success({
                title: t("register.success"),
                content: h("div", {}, [h("p", t("register.sucInfo"))]),
                onOk() {
                  router.push("/login");
                },
              });
            } else {
              message.success(t("register.success"));
              nowAccount.value = params.Account;
              nowPassword.value = params.Password;
              isModalOpen.value = true;
            }
          }
        })
        .catch(function (error) {});
    } else {
      (params.EmailCode = VCode.value),
        axios
          .post("api/User/GetUserEmail", {
            Email: formState.value.email,
          })
          .then(function (response) {
            if (response.data.code != 200) {
              message.error(response.data.info);
            } else {
              if (response.data.ReturnData.length > 0) {
                message.error(t("register.emailDuplicate"));
              } else {
                btnLoading.value = true;
                axios
                  .post("api/User/SaveUser", params)
                  .then(function (response) {
                    btnLoading.value = false;
                    if (response.data.code != 200) {
                      message.error(response.data.info);
                    } else {
                      message.success(t("register.success"));
                      router.push("/login");
                    }
                  })
                  .catch(function (error) {});
              }
            }
          })
          .catch(function (error) {});
    }
  }
};
const emailCode = () => {
  if (!isDisabled.value) {
    if (formState.value.email) {
      axios
        .post("api/User/GetUserEmail", {
          Email: formState.value.email,
        })
        .then(function (response) {
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            if (response.data.ReturnData.length > 0) {
              message.error(t("register.emailDuplicate"));
            } else {
              emailDis.value = true;
              isDisabled.value = true;
              count.value = 60;
              startCountdown();
              axios
                .post("api/User/RegisterEmlie", {
                  Email: formState.value.email,
                })
                .then(function (response) {
                  if (response.data.code != 200) {
                    message.error(response.data.info);
                  } else {
                    VCode.value = response.data.ReturnData;
                  }
                })
                .catch(function (error) {});
            }
          }
        })
        .catch(function (error) {});
    } else {
      message.error(t("register.emailEmpty"));
      return;
    }
  }
};
const phoneCode = () => {
  if (!isDisabled.value) {
    if (formState.value.phone) {
      phoneDis.value = true;
      isDisabled.value = true;
      count.value = 60;
      startCountdown();
      axios
        .post("api/User/RegisterMobile", {
          Mobile: formState.value.phone,
        })
        .then(function (response) {
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            VCode.value = response.data.ReturnData;
          }
        })
        .catch(function (error) {});
    } else {
      message.error(t("register.phoneEmpty"));
      return;
    }
  }
};
function modalEmailCode() {
  if (nowAccount.value) {
    if (modalFormState.value.email) {
      axios
        .post("api/User/GetUserEmail", {
          Email: modalFormState.value.email,
        })
        .then(function (response) {
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            if (response.data.ReturnData.length > 0) {
              message.error(t("register.emailDuplicate"));
            } else {
              modalEmailDis.value = true;
              isCodeDisabled.value = true;
              count.value = 60;
              startModalCountdown();
              axios
                .post("api/User/RegisterEmlie", {
                  Email: modalFormState.value.email,
                })
                .then(function (response) {
                  if (response.data.code != 200) {
                    message.error(response.data.info);
                  } else {
                    modalCode.value = response.data.ReturnData;
                  }
                })
                .catch(function (error) {});
            }
          }
        })
        .catch(function (error) {});
    } else {
      message.error(t("register.emailEmpty"));
      return;
    }
  }
}

function cancelModal() {
  isModalOpen.value = false;
  modalEmailDis.value = false;
  clearInterval(modalIntervalId);
  modalCodeinfo.value.textContent = t("register.getCode");
  isCodeDisabled.value = false;
}

function submitEmail() {
  console.log("流程1，点击提交");
  if (modalCode.value != modalFormState.value.code) {
    message.error("验证码错误!");
  } else {
    console.log("流程2，验证码正确");
    axios
      .post("api/User/GetAllowUsers", {
        Account: nowAccount.value,
      })
      .then(function (response) {
        if (response.data.code != 200) {
          message.error(response.data.info);
        } else {
          let params = response.data.ReturnData[0];
          params.Email = modalFormState.value.email;
          params.Password = nowPassword.value;
          modalFormRef.value
            .validate()
            .then(() => {
              axios
                .post("api/User/AllowSave", params)
                .then(function (response) {
                  if (response.data.code != 200) {
                    message.error(response.data.info);
                  } else {
                    message.success(response.data.ReturnData);
                    router.push("/login");
                  }
                })
                .catch(function (error) {});
            })
            .catch(() => {});
        }
      })
      .catch(function (error) {});
  }
}

function getUrl() {
  // 获取参数部分
  let l = route.query.l;
  let type = route.query.type;
  if (l) {
    if (l == "zh_cn") {
      lang.value = localStorage.getItem("lang");
      if (lang.value != "zh") {
        i18n.locale = "zh";
        localStorage.setItem("lang", "zh");
        lang.value = "zh";
        location.reload();
      }
    } else {
      lang.value = localStorage.getItem("lang");
      if (lang.value != "en") {
        i18n.locale = "en";
        localStorage.setItem("lang", "en");
        lang.value = "en";
        location.reload();
      }
    }
  }
  if (l == "zh_cn") {
    isCam.value = true;
  }
  isChina.value = localStorage.getItem("lang") == "zh" ? true : false;
}
const info = () => {
  Modal.info({
    title: t("register.subSuc"),
    content: h("div", {}, [h("p", t("register.subInfo"))]),
    onOk() {},
  });
};
const checked = () => {
  if (artificial.value == true) {
    Modal.info({
      title: t("register.noCode"),
      content: h("div", {}, [h("p", t("register.noCodein"))]),
      onOk() {},
    });
  }
};
onMounted(() => {
  // 在这里你可以添加其他的初始化代码
});
onUnmounted(() => {
  clearInterval(intervalId);
  clearInterval(modalIntervalId);
});
</script>

<style scoped>
.register {
  width: 100%;
  height: 100vh;
  color: black;
  position: relative;
  background: #ffffff url("@/assets/img/register.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}
.top {
  color: white;
  position: absolute;
  top: 10%; /* 垂直居中 */
  right: 50%;
  transform: translate(50%, 10%); /* 移动中心点位置 */
  margin: 0px;
}
.regbox {
  width: 500px;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 50%; /* 垂直居中 */
  left: 50%;
  transform: translate(-50%, -50%); /* 移动中心点位置 */
  border-radius: 10px;
  overflow-y: visible;
  -moz-box-shadow: 5px 5px 30px black;
  -webkit-box-shadow: 5px 5px 30px black;
  box-shadow: 5px 5px 30px black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
h1,
h2,
h3 {
  text-align: center;
  margin: 30px;
}
h3 {
  font-size: 24px;
}
.inputbox {
  width: 80%;
}
.codebox {
  width: 80%;
  display: flex;
  justify-content: space-between;
}
.codebox input {
  width: 50%;
}
.ant-form-item {
  margin-bottom: 18px;
}
/*input {
  width: 100%;
  height: 40px;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  padding: 6px 12px;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  font-size: 14px;
  line-height: 1.42857143;
  box-sizing: border-box;
  outline: none;
  margin-bottom: 25px;
}
input:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  border: 1px solid rgba(81, 203, 238, 1);
}*/
.regbtn {
  width: 80%;
  height: 40px;
  border-radius: 1px;
  background-color: rgba(28, 132, 198, 1);
  cursor: pointer;
  text-align: center;
  color: white;
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 30px;
}
.disabledbtn {
  background-color: gray;
  cursor: not-allowed;
  display: inline-block;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  text-align: center;
  width: 100%;
  height: 32px;
  line-height: 32px;
}
.codebtn {
  display: inline-block;
  border-radius: 4px;
  background-color: #3d405b;
  border: none;
  color: #ffffff;
  text-align: center;
  width: 100%;
  height: 32px;
  line-height: 32px;
  transition: all 0.5s;
  cursor: pointer;
}

.codebtn span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.codebtn span:after {
  content: "»";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -15px;
  transition: 0.5s;
}

.codebtn:hover span {
  padding-right: 15px;
}

.codebtn:hover span:after {
  opacity: 1;
  right: 0;
}

.error {
  position: absolute;
  bottom: 90px;
  text-align: left;
  width: 80%;
  color: red;
}

.back {
  position: absolute;
  left: 20px;
  top: 20px;
  color: #0099ff;
  font-size: 16px;
  cursor: pointer;
}
</style>
